import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { useAuth } from '../../AuthContext';
import { useResolution } from '../../contexts/ResolutionContext';
import Timer from '../Common/Timer';
import { useLanguage } from '../../contexts/LanguageContext';

const ProfileHeader = ({ onLogout, onOpenAddModal }) => {
	const navigate = useNavigate();
	const { currentUser } = useAuth();
	const { person, isAddAllowed } = useResolution();

	const { t } = useLanguage();

	if (!person) {
		return <div>{t('loading')}</div>;
	}

	return (
		<div className='bg-white p-6 rounded-lg shadow-lg mb-6'>
			{/* Header with Name and Add Resolution Action */}
			<div className='flex flex-col sm:flex-row sm:justify-between sm:items-center mb-6 gap-4'>
				<h1 className='text-xl sm:text-2xl font-bold'>
					{`${person.displayName || `${person.name} ${person.surname}`} ${t('resolutions')}`}
				</h1>
				{/* Add Resolution button logic */}
				{currentUser && isAddAllowed(currentUser, person) && (
					<div className='flex flex-col items-end'>
						<button
							onClick={onOpenAddModal}
							disabled={!person.authEnabled}
							className={`px-2 py-1 sm:px-4 sm:py-2 rounded-md text-xs sm:text-sm font-semibold transition-colors ${
								person.authEnabled
									? 'bg-green-500 text-white hover:bg-green-600'
									: 'bg-gray-300 text-gray-500 cursor-not-allowed'
							}`}
						>
							{t('addResolution')}
						</button>
						{!person.authEnabled && (
							<div className='mt-1 text-xs text-gray-500 text-right max-w-[180px]'>
								{t('claimAccount')}
							</div>
						)}
					</div>
				)}
			</div>
			{/* Timer Display */}
			<div className='border-t pt-4'>
				<div className='text-center'>
					<h2 className='text-lg font-semibold text-gray-800 mb-4'>{t('timeUntilNewYear')}</h2>
					<div className='p-4'>
						<Timer
							targetYear={new Date().getFullYear() + 1}
							timerType={person.timerPreference || 'basic'}
							showEndedMessage={true}
						/>
					</div>
				</div>
			</div>
		</div>
	);
};

export default ProfileHeader;
